var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28H2v2h28v-2h-2zM19.971 8H24V7h-4.029v1zm-2 15h5v-2h-5v-2h5v-2h-5v-2h5v-2h-5v-3H26v16h2V9a1 1 0 00-1-1h-1V6a1 1 0 00-1-1h-6.029a1 1 0 00-1 1v2h-1a1 1 0 00-1 1v17h2v-3zM6 25h3v-2H6v-1h3v-2H6v-1h3v-2H6v-2h6v11h2V14a1 1 0 00-1-1H5a1 1 0 00-1 1v12h2v-1zM4.985 5.313c.116 0 .231.02.343.063a1 1 0 001.243-.48 1.635 1.635 0 011.46-.895c.725 0 1.374.487 1.575 1.184a1 1 0 00.961.722h.017a.688.688 0 110 1.377H4.985a.986.986 0 010-1.971m0 3.97h5.6a2.691 2.691 0 002.687-2.688c0-1.242-.847-2.29-1.994-2.597A3.66 3.66 0 008.031 2a3.623 3.623 0 00-2.806 1.323A2.988 2.988 0 002 6.298a2.989 2.989 0 002.985 2.986"
  })))));
}

export default SvgIconCity;